<template>
  <div id="app" :class="$mq">
    <div v-if="isLoading" class="loader">

      <span class="load-barspan">Ilhem is loading</span>
      <div class="load-bar">
        <div class="bar"></div>
        <div class="bar"></div>
        <div class="bar"></div>
      </div>
    </div>
    <div class="gif-screen">
      <img class="gif" :src="currGif" :class="$mq">
    </div>
    <div class="gif-home-ctnr">
      <transition name="homeGif">
        <img v-if="homeGifIsShown" class="gif home" src="/static/gifs/home.gif" :class="$mq">
      </transition>
    </div>

    <div class="background"></div>


    <div class="preload" v-images-loaded:on.done="loaded">
      <img class="gif" src="/static/gifs/musicin.gif">
      <img class="gif" src="/static/gifs/musicout.gif">
      <img class="gif" src="/static/gifs/videoin.gif">
      <img class="gif" src="/static/gifs/videoout.gif">
      <img class="gif" src="/static/gifs/gigsin.gif">
      <img class="gif" src="/static/gifs/gigsout.gif">
      <img class="gif" src="/static/gifs/ilhemin.gif">
      <img class="gif" src="/static/gifs/ilhemout.gif">
      <img src="./assets/img/bio/07.jpg">
      <img src="./assets/img/bio/06.jpg">
      <img src="./assets/img/bio/05.jpg">
      <img src="./assets/img/bio/04.jpg">
      <img src="./assets/img/bio/03.jpg">
      <img src="./assets/img/bio/02.jpg">
      <img src="./assets/img/bio/01.jpg">
    </div>


    <transition name="nav">
      <nav :class="$mq" v-if="navIsShown">
        <div @click="changeGif('musicIN')" class="nav-item music" :class="$mq">
          <span>music</span>
        </div>
        <div @click="changeGif('videoIN')" class="nav-item video" :class="$mq">
          <span>video</span>
        </div>
        <a target="_blank" href="https://www.facebook.com/ladyilhem/" class="icon share fb" :class="$mq">
          <Fb></Fb>
        </a>
        <div @click="changeGif('gigsIN')" class="nav-item gigs" :class="$mq">
          <span>gigs</span>
        </div>
        <div @click="showMail()" class="icon share mail" :class="$mq">
          <Mail></Mail>
        </div>
        <div v-show="mailIsShown" class="pop-up-mail" >
          <span :class="$mq">music@ilhem.com</span>
        </div>
        <div @click="changeGif('ilhemIN')" class="nav-item ilhem" :class="$mq">
          <span>ilhem</span>
        </div>
        <a target="_blank" href="https://www.instagram.com/ilhemdotcom/" class="icon share insta" :class="$mq">
          <Insta></Insta>
        </a>
      </nav>
    </transition>

    <transition name="page">
      <div v-if="musicIsShown" class="page-site">
        <div @click="changeGif('musicOUT')" class="icon close">
          <Close></Close>
        </div>
        <div class="page-container">
          <div class="content-wrapper">
            <div class="soundcloud-wrapper">
              <div class="soundcloud-ctnr">
                <iframe width="100%" height="300" scrolling="no" frameborder="no" allow="autoplay" src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/357448997&color=%23ff5500&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true&visual=true"></iframe>
              </div>
            </div>
            <div class="soundcloud-wrapper">
              <div class="soundcloud-ctnr">
                <iframe width="100%" height="300" scrolling="no" frameborder="no" allow="autoplay" src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/357447180&color=%23ff5500&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true&visual=true"></iframe>
              </div>
            </div>
            <div class="soundcloud-wrapper">
              <div class="soundcloud-ctnr">
                <iframe width="100%" height="300" scrolling="no" frameborder="no" allow="autoplay" src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/357447016&color=%23ff5500&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true&visual=true"></iframe>
              </div>
            </div>
            <div class="soundcloud-wrapper">
              <div class="soundcloud-ctnr">
                <iframe width="100%" height="300" scrolling="no" frameborder="no" allow="autoplay" src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/357445554&color=%23ff5500&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true&visual=true"></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <transition name="page">
      <div v-if="videoIsShown" class="page-site">
        <div @click="changeGif('videoOUT')" class="icon close iconwhite">
          <Close></Close>
        </div>
        <div class="page-container">
          <div class="page-wrapper">
            <div class="video-item">
              <h1 @click="destroyTitle()" style="font-size: 25.5vw;" :class="$mq">ted</h1>
              <iframe max-width="150px" width="100%" height="315" src="https://www.youtube.com/embed/a_BgjvvCD-8" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
            </div>
            <div class="video-item">
              <h1 @click="destroyTitle()" style="font-size: 25.5vw;" :class="$mq">uma</h1>
              <iframe max-width="150px" width="100%" height="315" src="https://www.youtube.com/embed/igZ4y_UcvOo" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
            </div>
            <div class="video-item">
              <h1 @click="destroyTitle()" style="font-size: 25.5vw;" :class="$mq">free</h1>
              <iframe width="100%" height="315" src="https://www.youtube.com/embed/8dcmuTgxbnM" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <transition name="page">
      <div v-if="gigsIsShown" class="page-site">
        <div @click="changeGif('gigsOUT')" class="icon close">
          <Close></Close>
        </div>
        <div class="page-container onepage gigs">
          <div class="content-wrapper">
            <br>
            <br>
            <p class="white pgigs">.Ilhem is putting all her time and energy on her next project</p>
          </div>
        </div>
      </div>
    </transition>

    <transition name="page">
      <div v-if="ilhemIsShown" class="page-site">
        <div @click="changeGif('ilhemOUT')" class="icon close">
          <Close></Close>
        </div>
        <div class="content-wrapper">
            <div class="page-container">
              <div class="item-ilhem bio">
                <article class="bio">
                  <read-more more-str="|+|" :text="bio" link="#" less-str="|-|" :max-chars="479"></read-more>
                </article>
              </div>
              <div class="item-ilhem photo un">
                <img src="./assets/img/bio/00.jpg" alt="">
              </div>
              <div class="item-ilhem photo un">
                <img src="./assets/img/bio/01.jpg" alt="">
              </div>
              <div class="item-ilhem photo quatres">
                <img src="./assets/img/bio/04.jpg" alt="">
              </div>
              <div class="item-ilhem photo cinq">
                <img src="./assets/img/bio/05.jpg" alt="">
              </div>
              <div class="item-ilhem photo six">
                <img src="./assets/img/bio/06.jpg" alt="">
              </div>
              <div class="item-ilhem photo sept">
                <img src="./assets/img/bio/07.jpg" alt="">
              </div>
              <div class="item-ilhem photo sept">
                <img src="./assets/img/bio/10.png" alt="">
              </div>
              <div class="item-ilhem photo sept" >
                <img src="./assets/img/bio/11.jpg" alt="">
              </div>
              <div class="item-ilhem photo sept">
                <img src="./assets/img/bio/12.jpg" alt="">
              </div>
            </div>
          </div>
      </div>
    </transition>

    <router-view/>
  </div>
</template>

<script>
import Fb from './assets/icons/fb.svg'
import Mail from './assets/icons/mail.svg'
import Close from './assets/icons/close.svg'
import Insta from './assets/icons/insta.svg'
import Nav from './components/Nav'
import imagesLoaded from 'vue-images-loaded'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'


export default {
  name: 'App',
  data() {
    return {
      a: '/static/gifs/home.gif',
      b: '/static/gifs/musicin.gif',
      c: '/static/gifs/musicout.gif',
      d: '/static/gifs/videoin.gif',
      e: '/static/gifs/videoout.gif',
      f: '/static/gifs/gigsin.gif',
      g: '/static/gifs/gigsout.gif',
      h: '/static/gifs/ilhemin.gif',
      i: '/static/gifs/ilhemout.gif',
      isLoading: true,
      currGif: '',
      homeGifIsShown: true,
      navIsShown: true,
      musicIsShown: false,
      videoIsShown: false,
      gigsIsShown: false,
      ilhemIsShown: false,
      mailIsShown: false,
      bio: '<p>The fact that her name literally translates to ‘inspiration’ didn’t seem like a coincidence to those who heard Ilhem sing.<br><br>While  this  ability  was  innate  to  her  as  breathing,  she  also  had  an  intuitive  understanding  that  natural  talent  could  only  carry  one  so  far,  and  that  the  artists  she  idolized  had  spilled  an  ocean  of  sweat  before  they  could make  their  craft  seem  so  effortless.  Ilhem  wasn’t  even  a  teenager  when  she  was  discovered  by  France’s  Grande  Dame  of  jazz,  Elene  Dee,  who  took  the  young  singer  under  her  wings  and  onto  the  stages  of  Lyon,  Paris  and  New  York.  Born  in  Lyon  to  a  German/Hungarian  mother  and  an  Algerian  father,  her  sound  is  international  as  the  wide  range  of  cities  she  lived  in,  such  as  Berlin,  London,  Istanbul,  Cape  Town,  Ibiza,  and  now  Paris.  She  has  also  performed  at  some  of  the  most  coveted  venues  around  the  world,  in  Barcelona,  Shanghai,  Rome,  London,  Paris,  establishing  an  international  sound  that  presents  a  natural  axis  between  soul, jazz and world music.<br><br>With  this  vagabond  life  came  an  acute  appreciation  of  the  diversity  of  human  existence as well as her voice as a woman;  of  the  cultures,  rituals,  and  endemic  injustices  that  defined  the  communities  she  embraced  as  was  embraced  by.  She  also  came  to  understand  the  universality  of  music  -  from  the  jungles  of  Peru  to  the  monasteries  of  Myanmar,  she learned  how  the  voice  and  chanting  is  an  essential  element  of  healing  and  meditating  in  so  many  ancient  cultures.<br>This  gave  way  to  her  endeavors  as  a  sound  yoga  and  meditation  teacher, certificated by the « Institut des arts de la voix » in France,  using  her  diligently  trained  voice  to  create  a  more  transcendent  experience.<br><br><a href="http://www.facebook.com/umay.ilhem">more infos here</a><br><br>This  wholistic  progression  is  evident  in  Ilhem’s  myriad  collaborations  with  songwriters and musicians  (Ken Rose, Damien Vandesande, Matti  Klein,  Bokar Cisshoko, Askin  Arsunan,  Bjorn  Werra,  Sebastian  Borkowsky)  and  underground  electronic  producers  (dOp,  Luciano,  Masomenos,  Mike  Shannon).  Her  encounters  with  such  diversely  talented  musicians  informed  Illhem’s  craft  in  a  way  that  was  like  a  painter  being  given  an  entirely  new  spectrum  of  color  to  paint  with.  After signing with the publishing company TRUELOVE Music (UK), our  dedicated  songstress  decided  to  produce  her  debut  unencumbered  by  marketplace  shackles,  leaving  the  next  release  by  Ilhem  as  an  uncompromised  portrayal  of  her  own  storied  life,  and  of  the  many  lives  with whom  hers  intersected.<br><br>Ilhem has been as well during the past years making herself a name as a performance artist, participating at various experimental festivals (Experiment Intrinsic-UK, Perm-Berlin). She created in 2018 the performance « Dôme » , an immersive experience using  a self-developped anechoic device (Galerie Perpitch Bringand, Paris). She is as well currently co-creating a dance and sound based piece with the syrian choreograph Medhat Aldabaal (Sascha Waltz).<br><br>Having  spent  her  life  breathing  in  a  lifetime  of  musical  inspiration,  she  would  now  close  her  eyes  and  exhale.</p>'
    }
  },
  components: {
    Nav,
    Fb,
    Insta,
    Close,
    Mail,
    'PulseLoader': PulseLoader
  },
  methods: {
    destroyTitle(e) {
      // e = e || window.event;
      // var o = e.srcElement || e.target;
      // o.className = "active";
      // window.event.srcElement.className = "active"
      $(event.target).addClass('active');
    },
    showMail() {
      console.log('show mail');
      this.mailIsShown = !this.mailIsShown;
    },
    changeGif(index) {
      if(index === 'musicIN'){
        this.homeGifIsShown = false;
        this.currGif = this.b;
        this.musicIsShown = true;
        this.navIsShown = false;
        this.mailIsShown = false;
      }
      if(index === 'musicOUT'){
        var self = this;
        this.currGif = this.c;
        this.musicIsShown = false;
        this.navIsShown = true;
        this.reload();
      }
      if(index === 'videoIN'){
        this.currGif = this.d;
        this.videoIsShown = true;
        this.navIsShown = false;
        this.mailIsShown = false;

        this.homeGifIsShown = false;
      }
      if(index === 'videoOUT'){
        var self = this;
        this.currGif = this.e;
        this.videoIsShown = false;
        this.navIsShown = true;
        this.reload();
      }
      if(index === 'gigsIN'){
        this.currGif = this.f;
        this.gigsIsShown = true;
        this.navIsShown = false;
        this.mailIsShown = false;

        this.homeGifIsShown = false;
      }
      if(index === 'gigsOUT'){
        var self = this;
        this.currGif = this.g;
        this.gigsIsShown = false;
        this.navIsShown = true;
        this.reload();
      }
      if(index === 'ilhemIN'){
        this.currGif = this.h;
        this.ilhemIsShown = true;
        this.navIsShown = false;
        this.mailIsShown = false;

        this.homeGifIsShown = false;
      }
      if(index === 'ilhemOUT'){
        var self = this;
        this.currGif = this.i;
        this.ilhemIsShown = false;
        this.navIsShown = true;
        this.reload();
      }
    },
    imageProgress(instance, image ) {
        const result = image.isLoaded ? 'loaded' : 'broken';
        console.log( 'image is ' + result + ' for ' + image.img.src );
    },
    loaded(){
      console.log('loaded')
        this.isLoading = false;
    },
    reload() {
      setTimeout(() => {
        console.log('!')
          this.homeGifIsShown = true;
        }, 2000);
    }
  },
  mounted() {
    this.changeGif('home');
    console.log('mounted');
  },
  created() {
    console.log('created');
  },
  directives: {
    imagesLoaded,
  }
}
</script>

<style>
@import 'assets/styles/reset.css';
@import 'assets/styles/global.css';


a {
  color: white;
}

.load-bar {
  position: relative;
  margin-top: 20px;
  width: 100%;
  height: 6px;
  background-color: #000000;
  top: 44%;
}
.load-barspan {
  position: relative;
  display: block;
  margin-top: 50px;
  top: 40%;
}
.bar {
  content: "";
  display: inline;
  position: absolute;
  width: 0;
  height: 100%;
  left: 50%;
  text-align: center;
}
.bar:nth-child(1) {
  background-color: #000000;
  animation: loading 3s linear infinite;
}
.bar:nth-child(2) {
  background-color: #e9e9e9;
  animation: loading 3s linear 1s infinite;
}
.bar:nth-child(3) {
  background-color: #FFFFFF;
  animation: loading 3s linear 2s infinite;
}
@keyframes loading {
    from {left: 50%; width: 0;z-index:100;}
    33.3333% {left: 0; width: 100%;z-index: 10;}
    to {left: 0; width: 100%;}
}

.preload {
  display: none;
}
.loader {
  position: absolute;
  top: 0;
  height: 100%;
  width: 100%;
  background: white;
  z-index: 1000;
}
.loader-img {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 150px;
  height: 150px;
}
html, body {
  position: relative;
  width: 100%;
  height: 100%;
  background: white;
}
.background {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  background: url('./assets/img/background.jpg') no-repeat center center;
  background-size: cover;
  z-index: 1;
}
.gif-screen {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  z-index: 10;
}
.gif {
  position: relative;
  height: 100%;
  left: 50%;
  top: 50%;
  display: block;
  transform: translate(-50%, -50%);
  z-index: 10;
}
.gif.home {
  position: absolute;
}
.gif.mobile {
  /* height: 90%; */
}
.homeGif-active, .homeGif-leave-active {
  transition: all 0s ease-out;
}
.homeGif-enter, .homeGif-leave-to {
  opacity: 0;
  transition: all 0.25s ease-out;
}
.gif-home-ctnr {
  overflow: hidden;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
}
#app {
  position: relative;
  font-family: Overpass;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: black;
  width: 100%;
  height: 100%;
  font-size: 16px;
  /* max-width: 1200px; */
  margin: auto;
  /* overflow: hidden; */
}
#app.tablet {
  font-size: 15px;
}
#app.mobile {
  font-size: 14px;
}
/* NAV */
nav {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  font-size: 6em;
  overflow: hidden;
  z-index: 10;
}
nav.mobile {
  font-size: 5em;
}
.nav-item {
  font-family: Bowlby;
  position: absolute;
  cursor: pointer;
}
.nav-item.music {
  top: 20px;
  left: 30px;
}
.nav-item.music.mobile {
  top: 0px;
  left: 4px;
}
.nav-item.video {
  right: -80px;
  transform: rotate(90deg);
  top: 134px;
}
.nav-item.video.mobile {
  top: 84px;
}
.nav-item.video.mobile {
  right: -70px;
  top: 84px;
}
.nav-item.gigs {
  bottom: 15px;
  right: 32px;
  transform: rotate(-180deg);
}
.nav-item.gigs.mobile {
  bottom: -3px;
  right: 8px;
}
.nav-item.ilhem {
  bottom: 126px;
  transform: rotate(-90deg);
  left: -80px;
}
.nav-item.ilhem.mobile {
  /* left: -50px; */
  bottom: 82px;
}
.toggleTest {
  position: absolute;
  bottom: 0;
  width: 100px;
  height: 100px;
  cursor: pointer;
  z-index: 100;
}
.icon {
  position: absolute;
  width: 40px;
  height: 40px;
  cursor: pointer;
}
.icon.share {
  width: 0.8em;
  height: 90px;
}
.icon.fb {
  bottom: 1.1em;
  right: 35px;
}
.icon.fb.mobile {
  bottom: 37px;
  right: 10px;
}
.icon.insta {
  left: 135px;
  bottom: 10px;
}
.icon.insta.mobile {
  left: 75px;
  bottom: -25px;
}
.icon.insta.tablet {
  left: 112px;
  bottom: 10px;
}
.icon.mail {
  top: 1.3em;
  left: 30px;
}
.icon.mail.mobile {
  top: 70px;
}
.icon.mail.mobile {
  left: 10px;
}
p.white {
  color: white;
}
/* svg:hover {
  fill: grey;
} */
.page-site {
  position: absolute;
  top: 1px;
  width: 100%;
  height: 100%;
  padding: 25px;
  box-sizing: border-box;
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
  z-index: 20;
}
.page-container {
  width: 100%;
  background: #00000066;
  margin: auto;
  max-width: 1000px;
}
.page-container.onepage {
  height: 100%;
}
.page-container.onepage.gigs {
  width: 90%;
  max-width: 700px;
}
.close {
  position: fixed;
  z-index: 100;
  padding: 8px;
  right: 30px;
}
.nav-enter-active, .nav-leave-active {
  transition: all 0.25s ease-out;
  transition-delay: 2s;
}
.nav-enter, .nav-leave-to {
  opacity: 0;
  transition-delay: 0s;
  transition: all .5s ease-out;
}
.iconwhite > svg {
  fill: white;
}
.content-wrapper {
  width: 100%;
}
/* PAGE MUSIC */
.page-wrapper {
  width: 100%;
  padding: 30px;
  box-sizing: border-box;
}
.page-enter-active, .page-leave-active {
  transition: all 0.25s ease-out;
  transition-delay: 2.5s;
}
.page-enter, .page-leave-to {
  opacity: 0;
  transition-delay: .5s;
  transition: all 0.1s ease-out;
}
.pagevideo {
  background: black;
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
}
.video-item {
  position: relative;
  width: 100%;
  height: 500px;
  /* overflow: hidden; */
  margin-bottom: 15px;
}
.video-item > img {
  height: 130%;
  position: relative;
  left: 50%;
  transform: translate(-50%, -50%);
  top: 50%;
}
.video-item > iframe {
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}
.video-item > h1 {
  font-family: Bowlby;
  color: white;
  position: absolute;
  z-index: 1;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  cursor: pointer;
  /* pointer-events: none; */
  transition: opacity 0.25s ease-out;
}
.video-item > h1.active {
  opacity: 0;
  pointer-events: none;
}
.video-item > h1.desktop {
  font-size: 16em!important;
}
/* ILHEM */
.pageilhem {
  background: black;
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
}
.item-ilhem.bio {
  /* background: grey; */
  color: white;
  text-align: left;
  padding: 35px;
  font-size: 1.2em;
  line-height: 25px;
  margin-bottom: 15px;
}
.item-ilhem.photo {
  padding: 0px 25px 15px;
  /* overflow: scroll; */
  -webkit-overflow-scrolling: touch;
  /* background-size: cover; */
  margin-bottom: 15px;
}
.item-ilhem.photo > img {
  width: 100%;
  height: auto;
}
.soundcloud-wrapper {
  width: 100%;
  padding-bottom: 25px;
}
.soundcloud-wrapper:first-child {
  padding-top: 25px;
}
.soundcloud-ctnr {
  width: 80%;
  margin: auto;
  max-width: 500px;
}
.pagemusic {
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
}
@media (max-width:1680px) and (max-height: 700px){
  body {
    /* display: none; */
  }
  .gif {
    height: 132%!important;
  }
}
@media (max-width:1680px) and (max-height: 780px){
  body {
    /* display: none; */
  }
  .gif {
    height: 123%!important;
  }
}
@media (max-width:1680px) and (max-height: 933px){
  body {
    /* display: none; */
  }
  .gif {
    height: 110%;
  }
}
/* @media (max-height:932px) {
  .gif {
    height: 135%;
  }
} */
@media (min-width:1680px){
  body {
    /* display: none; */
  }
  .gif {
    height: 110%;
  }
}
@media (min-width:1900px){
  body {
    /* display: none; */
  }
  .gif {
    height: 123%;
  }
}
#readmore {
  color: white;
}
.pgigs {
  text-align: left;
  padding: 15px;
  position: relative;
  /* top: 50%;left: 50%; */
  /* transform: translate(-50%, -50%); */
}
.pop-up-mail > span {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: black;
  color: white;
  padding: 7px;
  font-size: 9vw;
}
.pop-up-mail > span.desktop {
  font-size: 1em;
}
.pop-up-mail > span::selection {
  color: black;
  background: white;
}
.bio {
  font-size: 0.9em;
}
</style>



// WEBPACK FOOTER //
// src/App.vue